module.exports = __webpack_public_path__ + "img/def_malus_0.3b1f30d4.png";